module.exports = __webpack_public_path__ + "assets/image_add.6fbfc090.svg";